import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../models/RootState/RootState";

const RootStateInitialState: {
	rootStates: RootState[];
} = {
	rootStates: [],
};

export const RootStateReducer = createSlice({
	name: "__",
	initialState: RootStateInitialState,
	reducers: {
		setRootStates(state, { payload }) {
			state.rootStates = payload;
		},
	},
});
